import gql from 'graphql-tag'

export const INVOICES_BY_INVOICE_NUMBERS = gql`
  query InvoicesByInvoiceNumbers($invoiceNumbers: String! $open: Boolean) {
    invoicesByInvoiceNumbers(invoiceNumbers: $invoiceNumbers open: $open) {
        memberNumber
        invoiceDt
        dueDt
        invoiceNum
        productArea
        orderNum
        currencyCd
        createDt
        createBy
        description
        amount
        paid
        balance
        shipping
        adjustment
    }
  }
`

export const INVOICES_BY_MEMBER_NUMBER = gql`
  query InvoicesByMemberNumber($memberNumber: String! $open: Boolean) {
    invoicesByMemberNumber(memberNumber: $memberNumber open: $open) {
        memberNumber
        invoiceDt
        dueDt
        invoiceNum
        productArea
        orderNum
        currencyCd
        createDt
        createBy
        description
        amount
        paid
        balance
        shipping
        adjustment
    }
  }
`

export const LINE_ITEMS_BY_INVOICE_NUMBER = gql`
  query InvoiceLineItemsByInvoiceNumber($invoiceNumber: String!) {
    invoiceLineItemsByInvoiceNumber(invoiceNumber: $invoiceNumber) {
        lineTransDt
        createBy
        transTy
        descr
        lineTy
        qty
        unitPrice
        amount
        displayFl
    }
  }
`

export const INVOICES_BY_PROXY_TOKEN = gql`
  query InvoicesByProxyToken($token: String!) {
    invoicesByProxyToken(token: $token) {
      memberNumber
      invoiceDt
      dueDt
      invoiceNum
      productArea
      orderNum
      currencyCd
      createDt
      createBy
      description
      amount
      paid
      balance
      shipping
      adjustment
    }
  }
`

export const CREATE_DONATION_INVOICE = gql`
  mutation CreateDonationInvoice($memberNumber: String!, $fund: String!, $amount: Money!) {
    createDonationInvoice(memberNumber: $memberNumber, fund: $fund, amount: $amount) {
      invoices {
        invoiceNum,
        balance
      }
    }
  }
`

export const CREATE_SHOPPING_CART_INVOICES = gql`
  mutation CreateShoppingCartInvoices($cartId: String!) {
    createShoppingCartInvoices(cartId: $cartId) {
      invoices {
        invoiceNum,
        balance
      }
    }
  }
`

export const CREATE_EDUCATION_INVOICE = gql`
  mutation CreateEducationInvoice($amount: Money!, $orderSerno: String!) {
    createEducationInvoice(amount: $amount, orderSerno: $orderSerno) {
      redirectUrl
      invoices {
        invoiceNum,
        balance
      }
    }
  }
`

export const CREATE_SHOPPING_INVOICE = gql`
  mutation CreateShoppingInvoice($memberNumber: String!, $sessionSerno: String!) {
    createShoppingInvoice(memberNumber: $memberNumber, sessionSerno: $sessionSerno) {
      invoices {
        invoiceNum,
        balance
      }
    }
  }
`
